import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';
import { DateTime } from 'luxon';

export const fetchSpecialistCalendar = async (spcialistId: string) => {
  const dateTime = DateTime.local();
  const url = new URL(`${environment.SPECIALIST_URL}/schedule/${spcialistId}`);
  url.searchParams.append('timezone', dateTime.zoneName);

  const { data } = await HttpHandler({
    method: 'GET',
    url: url.toString(),
  });

  return Object.keys(data.scheduleWithTimezone)
    .sort()
    .reduce((obj: any, key) => {
      obj[key] = data.scheduleWithTimezone[key];
      return obj;
    }, {});
};
